import { useState } from "react";
import {
  goToQuantity,
  goToReview,
  nextStep,
} from "../../designer/store/slices/stepSlice";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import Steps from "./Steps";
import MobileMenu from "../../designer/components/layout/Header/MobileMenu";
import Preview from "../../designer/components/layout/Preview";
import ShareAndSave from "./ShareAndSave";
import ProjectDropdown from "../../designer/components/layout/Header/ProjectDropdown";

const Header = () => {
  const dispatch = useAppDispatch();

  const [showSaveSharePopup, setSaveSharePopup] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const quantity = useAppSelector(
    (state) => state.product.totalSelectedQuantity
  );
  const currentStep = useAppSelector((state) => state.steps.step);
  return (
    <>
      <div className=" bg-white flex gap-3 justify-between w-full shadow-header z-50 max-lg:h-[60px]">
        <div className="flex justify-start items-center">
          <MobileMenu />
          <a
            href="/"
            className="lg:mr-5 lg:px-5 max-lg:px-1 py-3 my-3 border-r border-solid border-lightgrey max-lg:border-none"
          >
            <img src="/logo.svg" alt="" />
          </a>
          <button className="lg:hidden">
            <svg
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.8616 21.5384C17.5414 21.5384 18.0924 20.9874 18.0924 20.3077C18.0924 19.6279 17.5414 19.0769 16.8616 19.0769C16.1819 19.0769 15.6309 19.6279 15.6309 20.3077C15.6309 20.9874 16.1819 21.5384 16.8616 21.5384Z"
                fill="black"
              />
              <path
                d="M33.2308 18.4614V20.6768C34.2778 21.9234 34.8836 23.4811 34.9539 25.1076C34.902 26.454 34.5002 27.7638 33.788 28.9076C33.0758 30.0515 32.0777 30.99 30.8923 31.6307V34.4614L28.0615 32.6153L25.9692 32.8614C24.2833 32.8189 22.651 32.2605 21.2923 31.2614H18.9539C19.8242 32.2596 20.9044 33.0531 22.1172 33.585C23.33 34.117 24.6454 34.3742 25.9692 34.3383H27.9385L32.3692 36.923V32.3691C33.5889 31.5836 34.5971 30.5108 35.3052 29.2447C36.0134 27.9786 36.3999 26.5579 36.4308 25.1076C36.4698 23.8243 36.1995 22.5505 35.6425 21.3937C35.0855 20.2369 34.2583 19.2312 33.2308 18.4614Z"
                fill="black"
              />
              <path
                d="M26.4615 21.5384C27.1412 21.5384 27.6923 20.9874 27.6923 20.3077C27.6923 19.6279 27.1412 19.0769 26.4615 19.0769C25.7817 19.0769 25.2307 19.6279 25.2307 20.3077C25.2307 20.9874 25.7817 21.5384 26.4615 21.5384Z"
                fill="black"
              />
              <path
                d="M19.3231 29.4154L22.0308 29.6615C23.3003 29.7118 24.5667 29.5029 25.7528 29.0477C26.939 28.5924 28.0199 27.9002 28.9297 27.0134C29.8396 26.1267 30.5592 25.0638 31.0447 23.8897C31.5303 22.7157 31.7716 21.455 31.7538 20.1846C31.7538 15.1385 26.8308 10.9539 22.0308 10.9539C17.2308 10.9539 11.5692 15.1385 11.5692 20.1846C11.5194 21.5761 11.7808 22.9611 12.3344 24.2387C12.888 25.5163 13.7199 26.6541 14.7692 27.5692V32.1231L19.3231 29.4154ZM13.1692 20.3077C13.1692 16.1231 16.9846 12.6769 22.0308 12.6769C27.0769 12.6769 30.1538 16.1231 30.1538 20.3077C30.1731 21.3629 29.9732 22.4106 29.5669 23.3846C29.1606 24.3587 28.5566 25.2378 27.7932 25.9665C27.0298 26.6952 26.1235 27.2577 25.1317 27.6183C24.1398 27.9789 23.0839 28.1298 22.0308 28.0615L19.0769 27.8154L16.3692 29.6615V26.8308C15.3799 26.0539 14.5785 25.0639 14.0244 23.9346C13.4704 22.8053 13.1781 21.5656 13.1692 20.3077Z"
                fill="black"
              />
              <path
                d="M21.6614 21.5384C22.3412 21.5384 22.8922 20.9874 22.8922 20.3077C22.8922 19.6279 22.3412 19.0769 21.6614 19.0769C20.9817 19.0769 20.4307 19.6279 20.4307 20.3077C20.4307 20.9874 20.9817 21.5384 21.6614 21.5384Z"
                fill="black"
              />
            </svg>
          </button>
          <Steps />
          <a
            onClick={() => {
              const win: any = window;

              win.top.postMessage(
                {
                  action: "closeDesigner",
                },
                "*"
              );
            }}
            href="javascript:void(0)"
            className="flex items-center ml-4 max-lg:ml-auto max-lg:mr-4 text-primaryred font-bold tracking-wider uppercase text-sm hover:text-red-700 transition-colors"
          >
            <svg
              className="mr-1"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8334 1.34169L10.6584 0.166687L6.00002 4.82502L1.34169 0.166687L0.166687 1.34169L4.82502 6.00002L0.166687 10.6584L1.34169 11.8334L6.00002 7.17502L10.6584 11.8334L11.8334 10.6584L7.17502 6.00002L11.8334 1.34169Z"
                fill="#E5312F"
              />
            </svg>
            Close Designer
          </a>
        </div>
        <div className="lg:px-6 flex items-center text-black">
          <ProjectDropdown />
          <div className="hidden lg:flex items-end gap-5 px-5 border-r border-solid border-lightgrey text-center text-xs uppercase">
            <div
              className="cursor-pointer"
              onClick={() => setShowPreview(true)}
            >
              <svg
                className="mx-auto mb-1"
                width="30"
                height="20"
                viewBox="0 0 33 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.5 21.9454C11.1291 21.9454 5.03167 16.7382 1.77768 13.5217C0.394962 12.1549 0.442347 9.97707 1.88681 8.67571C5.16656 5.72083 11.1886 1.05255 16.5 1.05255C21.8113 1.05255 27.8334 5.72083 31.113 8.67571C32.5575 9.97709 32.605 12.1549 31.2222 13.5217C27.9682 16.7382 21.8708 21.9454 16.5 21.9454Z"
                  stroke="black"
                  strokeLinejoin="round"
                />
                <path
                  d="M22.1068 11.4993C22.1068 14.6958 19.5737 17.2449 16.5005 17.2449C13.4274 17.2449 10.8943 14.6958 10.8943 11.4993C10.8943 8.30282 13.4274 5.75378 16.5005 5.75378C19.5737 5.75378 22.1068 8.30282 22.1068 11.4993Z"
                  stroke="black"
                />
              </svg>
              Previews
            </div>
            <div // Save Share Popup
              className="cursor-pointer"
              onClick={() => setSaveSharePopup(true)}
            >
              <svg
                className="mx-auto mb-1"
                width="20"
                height="23"
                viewBox="0 0 24 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.0964 9.47506C21.8367 9.47506 24 7.35378 24 4.80824C24 2.12128 21.8367 0 19.2406 0C16.5004 0 14.337 2.12128 14.337 4.66682C14.337 5.23249 14.4813 5.79817 14.6255 6.36384L7.99122 9.61648C5.9721 7.77803 2.94341 7.91945 1.21273 9.89931C-0.517946 11.8792 -0.373722 14.849 1.50118 16.546C3.37608 18.243 6.11632 18.243 7.99122 16.546L14.6255 19.7986C13.7602 22.2027 15.0582 24.8897 17.6542 25.7382C20.2502 26.5867 22.8462 25.314 23.7116 22.7684C24.5769 20.2229 23.2789 17.6773 20.6829 16.8288C18.9522 16.2632 17.2215 16.6874 15.9235 17.8188L9.28923 14.5661C9.57768 13.5762 9.57768 12.5863 9.28923 11.5963L15.9235 8.34371C16.7888 9.0508 17.9426 9.47506 19.0964 9.47506ZM19.0964 2.40412C20.3944 2.40412 21.5482 3.39405 21.5482 4.80824C21.5482 6.22243 20.5386 7.21236 19.0964 7.21236C17.7984 7.21236 16.6446 6.22243 16.6446 4.80824C16.6446 3.39405 17.7984 2.40412 19.0964 2.40412ZM4.81831 15.4146C3.37608 15.4146 2.36652 14.4247 2.36652 13.0105C2.36652 11.5963 3.37608 10.7478 4.81831 10.7478C6.26054 10.7478 7.27011 11.7378 7.27011 13.1519C7.27011 14.5661 6.11632 15.4146 4.81831 15.4146ZM19.0964 18.9501C20.3944 18.9501 21.5482 19.94 21.5482 21.3542C21.5482 22.7684 20.5386 23.7584 19.0964 23.7584C17.7984 23.7584 16.6446 22.7684 16.6446 21.3542C16.6446 19.94 17.7984 18.9501 19.0964 18.9501Z"
                  fill="#424447"
                />
              </svg>
              Share
            </div>
            <div className="cursor-pointer">
              <svg
                className="mx-auto mb-1"
                width="22"
                height="23"
                viewBox="0 0 26 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.86163 11.5385C6.54136 11.5385 7.0924 10.9875 7.0924 10.3077C7.0924 9.628 6.54136 9.07697 5.86163 9.07697C5.18189 9.07697 4.63086 9.628 4.63086 10.3077C4.63086 10.9875 5.18189 11.5385 5.86163 11.5385Z"
                  fill="black"
                />
                <path
                  d="M22.2308 8.46155V10.6769C23.2778 11.9235 23.8836 13.4812 23.9539 15.1077C23.902 16.4542 23.5002 17.7639 22.788 18.9077C22.0758 20.0516 21.0777 20.9901 19.8923 21.6308V24.4615L17.0615 22.6154L14.9692 22.8615C13.2833 22.819 11.651 22.2606 10.2923 21.2615H7.95386C8.82416 22.2598 9.90438 23.0532 11.1172 23.5852C12.33 24.1171 13.6454 24.3743 14.9692 24.3385H16.9385L21.3692 26.9231V22.3692C22.5889 21.5838 23.5971 20.5109 24.3052 19.2448C25.0134 17.9787 25.3999 16.5581 25.4308 15.1077C25.4698 13.8244 25.1995 12.5506 24.6425 11.3938C24.0855 10.237 23.2583 9.23128 22.2308 8.46155Z"
                  fill="black"
                />
                <path
                  d="M15.4616 11.5385C16.1413 11.5385 16.6924 10.9875 16.6924 10.3077C16.6924 9.628 16.1413 9.07697 15.4616 9.07697C14.7819 9.07697 14.2308 9.628 14.2308 10.3077C14.2308 10.9875 14.7819 11.5385 15.4616 11.5385Z"
                  fill="black"
                />
                <path
                  d="M8.32308 19.4153L11.0308 19.6615C12.3003 19.7118 13.5667 19.5029 14.7528 19.0476C15.939 18.5923 17.0199 17.9002 17.9297 17.0134C18.8396 16.1266 19.5592 15.0637 20.0447 13.8897C20.5303 12.7156 20.7716 11.4549 20.7538 10.1846C20.7538 5.13841 15.8308 0.953796 11.0308 0.953796C6.23077 0.953796 0.56923 5.13841 0.56923 10.1846C0.519378 11.576 0.780795 12.9611 1.33441 14.2386C1.88802 15.5162 2.71986 16.654 3.76923 17.5692V22.123L8.32308 19.4153ZM2.16923 10.3076C2.16923 6.12303 5.98461 2.67687 11.0308 2.67687C16.0769 2.67687 19.1538 6.12303 19.1538 10.3076C19.1731 11.3628 18.9732 12.4106 18.5669 13.3846C18.1606 14.3586 17.5566 15.2377 16.7932 15.9665C16.0298 16.6952 15.1235 17.2576 14.1317 17.6182C13.1398 17.9788 12.0839 18.1298 11.0308 18.0615L8.07692 17.8153L5.36923 19.6615V16.8307C4.37992 16.0538 3.57846 15.0639 3.02445 13.9345C2.47043 12.8052 2.17812 11.5655 2.16923 10.3076Z"
                  fill="black"
                />
                <path
                  d="M10.6616 11.5385C11.3413 11.5385 11.8923 10.9875 11.8923 10.3077C11.8923 9.628 11.3413 9.07697 10.6616 9.07697C9.98182 9.07697 9.43079 9.628 9.43079 10.3077C9.43079 10.9875 9.98182 11.5385 10.6616 11.5385Z"
                  fill="black"
                />
              </svg>
              Chat
            </div>
          </div>
          <div
            onClick={() => dispatch(goToQuantity())}
            className="flex ml-6 mr-8 cursor-pointer uppercase font-bold tracking-wider relative"
          >
            <svg
              className="mr-2"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.06682 2.25586H20.8337C21.9299 2.25586 21.8706 2.69808 21.7754 3.82601L21.1518 11.7466C21.0457 13.0088 21.1356 12.7026 19.7932 12.8942L7.46153 14.4572L8.11387 16.3424C13.4638 16.3424 16.0498 16.3424 21.3962 16.3424C21.5759 17.012 21.8203 18.1024 22 18.849H19.7932L19.5811 18.0863C15.1243 18.0863 13.4261 18.0863 8.96749 18.0863C6.53243 18.0451 6.77683 18.7022 6.19278 16.6056L2.00915 1.45199H0V0H3.5241C3.68763 0.610514 3.91407 1.63818 4.06682 2.25586ZM9.64859 18.6055C10.5885 18.6055 11.3522 19.3664 11.3522 20.3027C11.3522 21.2409 10.5885 22 9.64859 22C8.70691 22 7.94494 21.2409 7.94494 20.3027C7.94494 19.3664 8.70691 18.6055 9.64859 18.6055ZM16.6752 18.6055C17.6151 18.6055 18.3789 19.3664 18.3789 20.3027C18.3789 21.2409 17.6151 22 16.6752 22C15.7335 22 14.9716 21.2409 14.9716 20.3027C14.9716 19.3664 15.7353 18.6055 16.6752 18.6055Z"
                fill="black"
              />
            </svg>
            <span className="hidden lg:inline">Cart</span>
            <div className="absolute -right-3 -top-3 text-[11px] text-white bg-primaryred rounded-full px-1 pt-[1px] min-w-[18px] text-center">
              {quantity}
            </div>
          </div>
          {currentStep === 0 && (
            <button // Next Step Button
              onClick={() => dispatch(nextStep())}
              className="lg:my-4 lg:rounded-full max-lg:h-full bg-primaryred text-white py-3 px-5 uppercase font-bold tracking-wider"
            >
              Next <span className="hidden xl:inline">Step</span>
            </button>
          )}
        </div>
      </div>

      {showSaveSharePopup && (
        <ShareAndSave setSaveSharePopup={setSaveSharePopup}></ShareAndSave>
      )}

      <Preview show={showPreview} setShow={setShowPreview}></Preview>
    </>
  );
};

export default Header;
